import { io } from 'socket.io-client';

export const SOCKET_URL =
  process.env.REACT_APP_SOCKET_URL ||
  (process.env.NODE_ENV === 'development'
    ? 'http://localhost:5000'
    : 'https://api.sistemacfood.com.br');

let socket;

/** Retorna SEMPRE a mesma instância de socket (singleton). */
export function getSocket() {
  if (!socket) {
    socket = io(SOCKET_URL, {
      path: '/socket.io',
      transports: ['polling', 'websocket'],
      upgrade: false, 
      withCredentials: true,
      reconnectionAttempts: 5,
      timeout: 10000,
    });

    socket.on('connect', () => {
      console.log('🔌 Conectado via WebSocket');
    });

    socket.on('connect_error', (err) => {
      console.warn('⚠️ Erro na conexão Socket, tentando fallback...', err.message);
      // Se falhar apenas o websocket, você pode tentar reativar o polling aqui
    });
  }
  return socket;
}
